import { STORAGE_KEY } from '@/constants/storage';
import { $http } from '@/plugins/common/http';

export const getCards = () => {
    return $http.get('user/cards');
};

export const deleteCard = (id) => {
    return $http.delete('user/cards/' + id);
};

export const setDefaultCard = (id) => {
    return $http.patch('user/cards/' + id + '/default');
};

export const getAddCardForm = () => {
    return $http.get('user/cards/iframe-transaction');
};

export const addUserCard = (cardData) => {
    return $http.post('user/cards', cardData, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};

export const getCheckoutComplete = (orderId) => {
    return $http.get('/checkout/' + orderId + '/complete');
};

export const handlePayment = (data, dataEncrypt = false) => {
    return $http.post('checkout-one-step/payment', data, {
        ...(dataEncrypt && {
            headers: { [STORAGE_KEY.ENCRYPTION]: !!dataEncrypt },
        }),
    });
};

export const completeByStripe = (data) => {
    return $http.post('/checkout-one-step/complete/stripe', data);
};

export const updateOrderTemporaryPaymentMethod = (orderId, data) => {
    return $http.patch(`/checkout/${orderId}/payment-method`, data);
};
